export default "app-footer {\n\tdisplay: block;\n\tbox-sizing: border-box;\n\tborder-bottom: 100vh solid #17191a;\n\tbackground: #17191a;\n}\n";